import { Route, Routes } from 'react-router-dom'
import { ChatbotAnalyticPage } from 'pages/chatbot/pages/chatbotAnalytic/ui/ChatbotAnalyticPage'
import { ChatbotAnalyticAccessLayout } from 'pages/chatbot/pages/chatbotAnalytic/layout/ChatbotAnalyticAccessLayout'
import { ChatbotAnalyticLayout } from 'pages/chatbot/pages/chatbotAnalytic/layout/ChatbotAnalyticLayout'

export const ChatbotAnalyticRouter = () => {
  return (
    <Routes>
      <Route element={<ChatbotAnalyticLayout />}>
        <Route element={<ChatbotAnalyticAccessLayout />}>
          <Route path={'/'} element={<ChatbotAnalyticPage />} />
        </Route>
      </Route>
    </Routes>
  )
}
